import SEO from "../components/common/SEO";

const Terms = () => {
  return (
    <>
      <SEO
        title="Terms & Conditions | AZ Construction"
        description="Review the terms and conditions governing the use of AZ Construction's website and services."
        url="https://azconstruction.com/terms-of-service"
      />
      {/* Banner */}

      <section 
        className="relative pt-32 md:pt-40 pb-16 md:pb-28 overflow-hidden"
        style={{
          backgroundImage: "linear-gradient(rgba(8,43,87,.92), rgba(8,43,87,.92)), url('/images/legal-banner.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container-custom text-center relative z-10">

          <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold text-white">
            Terms of Service
          </h1>

          <p className="text-white/80 mt-6 max-w-3xl mx-auto">
            Please read these Terms of Service carefully before
            using the AZ Construction website and services.
          </p>

        </div>
      </section>

      {/* Content */}

      <section className="py-24 bg-white">
        <div className="container-custom">

          <div className="max-w-5xl mx-auto">

            <p className="text-gray-600 mb-10">
              Last Updated: June 2026
            </p>

            {/* Section 1 */}

            <div className="mb-12">

              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                1. Acceptance of Terms
              </h2>

              <p className="text-gray-600 leading-8">
                By accessing and using this website, you accept and
                agree to be bound by these Terms of Service. If you
                do not agree with any part of these terms, please do
                not use our website or services.
              </p>

            </div>

            {/* Section 2 */}

            <div className="mb-12">

              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                2. Our Services
              </h2>

              <p className="text-gray-600 leading-8">
                AZ Construction provides construction, property
                development, property consultancy, liaisoning
                services, and related professional solutions.
                Service availability may vary depending on project
                requirements, location and regulatory approvals.
              </p>

            </div>

            {/* Section 3 */}

            <div className="mb-12">

              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                3. User Responsibilities
              </h2>

              <ul className="list-disc pl-6 text-gray-600 space-y-3">
                <li>
                  Provide accurate and complete information when
                  contacting us.
                </li>

                <li>
                  Use the website in accordance with applicable laws.
                </li>

                <li>
                  Avoid any activity that may disrupt website
                  functionality or security.
                </li>

                <li>
                  Refrain from submitting false, misleading or
                  unauthorized information.
                </li>
              </ul>

            </div>

            {/* Section 4 */}

            <div className="mb-12">

              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                4. Intellectual Property
              </h2>

              <p className="text-gray-600 leading-8">
                All content on this website, including text, images,
                graphics, logos, branding, layouts and designs, is
                the property of AZ Construction unless otherwise
                stated. Unauthorized reproduction, distribution or
                modification is prohibited.
              </p>

            </div>

            {/* Section 5 */}

            <div className="mb-12">

              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                5. Project Estimates & Quotations
              </h2>

              <p className="text-gray-600 leading-8">
                Any estimates, quotations or project timelines
                provided through this website or consultation
                process are indicative and subject to change based
                on project scope, material costs, regulatory
                approvals and other factors.
              </p>

            </div>

            {/* Section 6 */}

            <div className="mb-12">

              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                6. Limitation of Liability
              </h2>

              <p className="text-gray-600 leading-8">
                AZ Construction shall not be liable for any direct,
                indirect, incidental, consequential or special
                damages arising from the use of this website or
                reliance on information provided herein.
              </p>

            </div>

            {/* Section 7 */}

            <div className="mb-12">

              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                7. Third-Party Links
              </h2>

              <p className="text-gray-600 leading-8">
                This website may contain links to third-party
                websites for convenience and informational
                purposes. We do not endorse or assume
                responsibility for the content, privacy policies
                or practices of external websites.
              </p>

            </div>

            {/* Section 8 */}

            <div className="mb-12">

              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                8. Privacy
              </h2>

              <p className="text-gray-600 leading-8">
                Your use of this website is also governed by our
                Privacy Policy, which explains how we collect,
                use and protect your personal information.
              </p>

            </div>

            {/* Section 9 */}

            <div className="mb-12">

              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                9. Termination
              </h2>

              <p className="text-gray-600 leading-8">
                We reserve the right to restrict or terminate
                access to our website or services without notice
                if users violate these Terms of Service or engage
                in unlawful activities.
              </p>

            </div>

            {/* Section 10 */}

            <div className="mb-12">

              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                10. Changes to Terms
              </h2>

              <p className="text-gray-600 leading-8">
                AZ Construction reserves the right to update,
                modify or replace these Terms of Service at any
                time. Changes become effective immediately upon
                publication on this page.
              </p>

            </div>

            {/* Section 11 */}

            <div>

              <h2 className="text-3xl font-bold text-[#082B57] mb-5">
                11. Governing Law
              </h2>

              <p className="text-gray-600 leading-8">
                These Terms of Service shall be governed and
                interpreted in accordance with the laws of India.
                Any disputes arising from the use of this website
                shall be subject to the jurisdiction of the
                courts of Madhya Pradesh, India.
              </p>

            </div>

            {/* Contact Box */}

            <div className="mt-16 bg-slate-50 rounded-3xl p-8 border border-gray-200">

              <h3 className="text-2xl font-bold text-[#082B57] mb-4">
                Contact Information
              </h3>

              <p className="text-gray-600 mb-2">
                <strong>AZ Construction</strong>
              </p>

              <p className="text-gray-600 mb-2">
                Email: contact@azconstruction.com
              </p>

              <p className="text-gray-600 mb-2">
                Phone: +91 99266 66609, +91 83195 69994
              </p>

              <p className="text-gray-600">
                Indore, Madhya Pradesh, India
              </p>

            </div>

          </div>

        </div>
      </section>
    </>
  );
};

export default Terms;